import moment from 'moment'

class Notification {

  #data = {}

  constructor(data={})
  {
    this.#data = data
  }

  /**
   * Property getters.
   */
  
  get cta()
  {
    return this.data('cta')
  }

  get icon()
  {
    return this.data('icon')
  }
  
  get id()
  {
    return this.#data.id
  }

  get message()
  {
    return this.data('message')
  }

  get readAt()
  {
    let readAt = this.#data.read_at

    return readAt ? moment(readAt) : null
  }

  get subtitle()
  {
    return this.data('subtitle')
  }

  /**
   * Computed properties.
   */
  
  get isRead()
  {
    return !!this.readAt
  }
  

  /**
   * Relationships.
   */
  
  

  /**
   * Methods.
   */
  
  data(prop)
  {
    return this.#data.data ? this.#data.data[prop] : null
  }

}

export default Notification